import * as FuncionesServices from "../../utils/funciones-services";

export const obtenerRequisitos = async (idSolicitudMultiple) => {
    let atributos = [{ campo: 'idSolicitudMultiple', valor: idSolicitudMultiple }]
    return FuncionesServices.manejarRespuesta({
        url: FuncionesServices.reemplazarUrlServicio(process.env.REACT_APP_WS_GET_REQUISITOS, atributos),
        method: 'GET',
        headers: new Headers({
            'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY,
            'Authorization': 'Bearer ' + FuncionesServices.getAccessToken(),
            'Iam-id-token': 'Bearer ' + FuncionesServices.getIamToken(),
            'Transaccion-Id'            : FuncionesServices.generarTransaccionId(),
            'Nombre-Servicio-Consumidor': process.env.REACT_APP_NOMBRE_SERVICIO_CONSUMIDOR,
            'Nombre-Aplicacion'         : process.env.REACT_APP_NOMBRE_APLICACION,
            'Usuario-Consumidor-Id'     : process.env.REACT_APP_USUARIO_CONSUMIDOR_ID,
            'Aplicacion-Id'             : process.env.REACT_APP_APLICACION_ID
        })
    })
}

export const obtenerListaUbicacion = async (parametros) => {
    return FuncionesServices.procesarRespuesta({
        url: FuncionesServices.agregarParametros(process.env.REACT_APP_WS_GET_UBICACION, parametros),
        method: 'GET',
        headers: new Headers({
            'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY,
            'Authorization': 'Bearer ' + FuncionesServices.getAccessToken(),
            'Iam-id-token': 'Bearer ' + FuncionesServices.getIamToken(),
            'transactionId': FuncionesServices.generarCorrelativo(),
            'correlationId': FuncionesServices.generarCorrelativo(),
            'businessProcess': process.env.REACT_APP_BUSINESS_PROCESS,
            'applicationName': process.env.REACT_APP_NOMBRE_APLICACION,
            'applicationUser': 'test'
        })
    })
}

export const obtenerCentrosMedicos = async (parametros) => {
    return FuncionesServices.procesarRespuesta({
        url: FuncionesServices.agregarParametros(process.env.REACT_APP_WS_GET_CENTROS_MEDICOS, parametros),
        method: 'GET',
        headers: new Headers({
            'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY,
            'Authorization': 'Bearer ' + FuncionesServices.getAccessToken(),
            'Iam-id-token': 'Bearer ' + FuncionesServices.getIamToken(),
            'transactionId': FuncionesServices.generarCorrelativo(),
            'correlationId': FuncionesServices.generarCorrelativo(),
            'businessProcess': process.env.REACT_APP_BUSINESS_PROCESS,
            'applicationName': process.env.REACT_APP_NOMBRE_APLICACION,
            'applicationUser': 'test'
        })
    })
}

export const registrarAgendaCita = async (idSolicitudMultiple, request) => {

    let atributos = [{ campo: 'idSolicitudMultiple', valor: idSolicitudMultiple }]
    return FuncionesServices.manejarRespuesta({
        url: FuncionesServices.reemplazarUrlServicio(process.env.REACT_APP_WS_POST_REQUISITO, atributos),
        method: 'POST',
        headers: new Headers({
            'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY,
            'Authorization': 'Bearer ' + FuncionesServices.getAccessToken(),
            'Iam-id-token': 'Bearer ' + FuncionesServices.getIamToken(),
            'Transaccion-Id'            : FuncionesServices.generarTransaccionId(),
            'Nombre-Servicio-Consumidor': process.env.REACT_APP_NOMBRE_SERVICIO_CONSUMIDOR,
            'Nombre-Aplicacion'         : process.env.REACT_APP_NOMBRE_APLICACION,
            'Usuario-Consumidor-Id'     : process.env.REACT_APP_USUARIO_CONSUMIDOR_ID,
            'Aplicacion-Id'             : process.env.REACT_APP_APLICACION_ID,
            'Content-Type': 'application/json'
        }),
        body: JSON.stringify({datos: request } )
    })
}

export const obtenerRequisitoScore = async (atributos, parametros, headers) => {
    return FuncionesServices.procesarRespuesta({
        url: FuncionesServices.agregarParametros(FuncionesServices.reemplazarUrlServicio(process.env.REACT_APP_WS_GET_REQUISITOS_SCORE,
            atributos), parametros),
        method: 'GET',
        headers: new Headers({
            'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY,
            'Authorization': 'Bearer ' + FuncionesServices.getAccessToken(),
            'Iam-id-token': 'Bearer ' + FuncionesServices.getIamToken(),
            'idTransaction': headers.idTransaction,
            'correlationId': FuncionesServices.generarCorrelativo(),
            'businessProcess': process.env.REACT_APP_BUSINESS_PROCESS,
            'nameApplication': 'SolicitudDigital',
            'userApplication': headers.userApplication,
            'Accept': 'application/json'
        })
    })
}

export const registrarRequisitosScore = async (request) => {
    return FuncionesServices.procesarRespuesta({
        url: process.env.REACT_APP_WS_POST_REQUISITOS_SCORE,
        method: 'POST',
        headers: new Headers({
            'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY,
            'Authorization': 'Bearer ' + FuncionesServices.getAccessToken(),
            'Iam-id-token': 'Bearer ' + FuncionesServices.getIamToken(),
            'transactionId': FuncionesServices.generarCorrelativo(),
            'correlationId': FuncionesServices.generarCorrelativo(),
            'businessProcess': process.env.REACT_APP_BUSINESS_PROCESS,
            'applicationName': process.env.REACT_APP_NOMBRE_APLICACION,
            'applicationUser': 'test',
            'Content-Type': 'application/json'
        }),
        body: JSON.stringify(request)
    })
}

export const obtenerRequisitosAdicional = async (idSolicitudMultiple) => {
    let atributos = [{ campo: 'idSolicitudMultiple', valor: idSolicitudMultiple }]
    return FuncionesServices.manejarRespuesta({
        url: FuncionesServices.reemplazarUrlServicio(process.env.REACT_APP_WS_GET_REQUISITOS_ADICIONAL, atributos),
        method: 'GET',
        headers: new Headers({
            'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY,
            'Authorization': 'Bearer ' + FuncionesServices.getAccessToken(),
            'Iam-id-token': 'Bearer ' + FuncionesServices.getIamToken(),
            'Transaccion-Id'            : FuncionesServices.generarTransaccionId(),
            'Nombre-Servicio-Consumidor': process.env.REACT_APP_NOMBRE_SERVICIO_CONSUMIDOR,
            'Nombre-Aplicacion'         : process.env.REACT_APP_NOMBRE_APLICACION,
            'Usuario-Consumidor-Id'     : process.env.REACT_APP_USUARIO_CONSUMIDOR_ID,
            'Aplicacion-Id'             : process.env.REACT_APP_APLICACION_ID,
        })
    })
}

export const registrarAgendaCitaAdicional = async (idSolicitudMultiple, request) => {
    let atributos = [{ campo: 'idSolicitudMultiple', valor: idSolicitudMultiple }]
    return FuncionesServices.manejarRespuesta({
        url: FuncionesServices.reemplazarUrlServicio(process.env.REACT_APP_WS_POST_REQUISITO_ADICIONAL, atributos),
        method: 'POST',
        headers: new Headers({
            'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUSCRIPTION_KEY,
            'Authorization': 'Bearer ' + FuncionesServices.getAccessToken(),
            'Iam-id-token': 'Bearer ' + FuncionesServices.getIamToken(),
            'Transaccion-Id'            : FuncionesServices.generarTransaccionId(),
            'Nombre-Servicio-Consumidor': process.env.REACT_APP_NOMBRE_SERVICIO_CONSUMIDOR,
            'Nombre-Aplicacion'         : process.env.REACT_APP_NOMBRE_APLICACION,
            'Usuario-Consumidor-Id'     : process.env.REACT_APP_USUARIO_CONSUMIDOR_ID,
            'Aplicacion-Id'             : process.env.REACT_APP_APLICACION_ID,
            'Content-Type': 'application/json'
        }),
        body: JSON.stringify({datos: request } )
    })
}